import React, {useEffect, useState} from 'react'
import {getAdminAllKYCList} from './ApproveKYCAPI'
import Swal from 'sweetalert2'
import {Link} from 'react-router-dom'
import styles from './ApproveKYCStyles/ApproveKYCStyles.module.scss'
import {CircularProgress} from '@mui/material'
import {adminAllKYCDataType} from './ApproveKYCDataType'
import PaginationComponent from '../../PaginationComponent/Pagination'

const ApproveKYCHome = () => {
  const [allKYC, setAllKYC] = useState<adminAllKYCDataType[]>()
  const [noKYCFound, setNoKYCFound] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [itemOffset, setItemOffset] = useState<number>(0)
  const [dataLength, setDataLength] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10
  const pageCount = Math.ceil(dataLength / itemsPerPage)

  // function to get list of all KYC
  async function getAllAdminKYCList() {
    setLoading(true)
    try {
      const {data: response} = await getAdminAllKYCList(itemOffset, itemsPerPage)
      if (response.code === '200') {
        setNoKYCFound(false)
        setAllKYC(response.data.kycList)
        setDataLength(response.data.totalKycList)
      } else if (response.code === '204') {
        setNoKYCFound(true)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getAllAdminKYCList()
  }, [itemOffset])

  // function to set the color for kyc status in all kyc table
  const setBadgeColor = (statusCode: number) => {
    switch (statusCode) {
      case 0:
        // for pending
        return 'badge-light-warning'
      case 1:
        // for Active
        return 'badge-light-success'
      case 2:
        // for processing
        return `${styles.status_processing}`
      case 3:
        // for rejected
        return 'badge-light-danger'
      case 4:
        // for resubmitted
        return `${styles.status_resubmitted}`
      case 5:
        // for terminated
        return 'badge-light-dark'
      default:
        return 'badge-light-warning'
    }
  }
  return (
    <>
      {loading ? (
        // {* Begin: loader*}
        <div
          className='d-flex justify-content-center align-items-center vh-70'
          style={{height: '70vh'}}
        >
          <CircularProgress />
        </div>
      ) : (
        // {* End: loader*}
        <div className='app-main flex-column flex-row-fluid'>
          {/* Begin: Approve KYC Heading  */}
          <div className='d-flex align-items-center gap-2 gap-lg-3 justify-content-between mb-5 px-5'>
            {/* Begin: Heading */}
            <h2
              className='page-heading d-flex text-dark fw-bold fs-3 my-0
            flex-column justify-content-center'
            >
              Approve KYC
            </h2>
            {/* End: Heading */}
          </div>
          {/* End: Approve KYC Heading  */}

          {/* Begin: Table */}
          <div id='table div'>
            <div className='card mb-5 mb-xl-8'>
              <div className='card-body py-3'>
                <div className='table-responsive'>
                  {/* begin::Table */}
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    {/* begin::Table head */}
                    {!noKYCFound && (
                      <thead>
                        <tr className='fw-bold text-muted'>
                          <th className='max-w-150px'>KYC Name</th>
                          <th className='max-w-150px'>Business details</th>
                          <th className='max-w-150px'>Conatct datails</th>
                          <th className='max-w-100px'>KYC status</th>
                          <th className='max-w-50px'>Actions</th>
                        </tr>
                      </thead>
                    )}
                    {/* end::Table head */}

                    {/* begin::Table body */}
                    <tbody>
                      {noKYCFound ? (
                        <tr>
                          <td colSpan={5}>
                            <span className='d-flex flex-column align-items-center flex-start p-10'>
                              <img
                                src='/media/svg/undraw/property.svg'
                                alt='No document uploaded'
                                className='h-200px w-200px'
                              />
                              <span className='fw-bold text-muted fs-1 text-center'>
                                No KYC is present
                              </span>
                            </span>
                          </td>
                        </tr>
                      ) : (
                        allKYC?.map((kyc, index: number) => {
                          return (
                            <tr key={index}>
                              <td className='max-w-150px'>
                                <div className='d-flex justify-content-start flex-column'>
                                  <Link
                                    to={`/approve_kyc/${kyc.account_kyc_uuid}`}
                                    className='text-truncate max-w-150px text-dark fw-bold text-hover-primary fs-6'
                                    title={kyc.account_kyc_name}
                                  >
                                    {kyc.account_kyc_name}
                                  </Link>
                                  <span
                                    className='text-truncate max-w-150px text-muted fw-semibold text-muted d-block fs-7'
                                    title={kyc.kyc_accouont_holder_name}
                                  >
                                    {kyc.kyc_accouont_holder_name}
                                  </span>
                                </div>
                              </td>
                              <td className='max-w-150px'>
                                <div className='d-flex justify-content-start flex-column'>
                                  <div
                                    className='text-truncate max-w-150px text-dark fw-bold text-hover-primary fs-6'
                                    title={kyc.business_name}
                                  >
                                    {kyc.business_name ? kyc.business_name : '-'}
                                  </div>
                                  <span
                                    className='text-truncate max-w-150px text-muted fw-semibold text-muted d-block fs-7'
                                    title={kyc.business_registartion_type_name}
                                  >
                                    {kyc.business_registartion_type_name}
                                  </span>
                                </div>
                              </td>
                              <td className='max-w-150px'>
                                <div className='d-flex justify-content-start flex-column'>
                                  <div
                                    className='text-dark fw-bold text-hover-primary fs-6 text-truncate max-w-200px'
                                    title={kyc.kyc_contact_number}
                                  >
                                    {kyc.kyc_contact_number}
                                  </div>
                                  <span
                                    className='text-muted fw-semibold text-muted d-block fs-7 text-truncate max-w-200px'
                                    title={kyc.kyc_email_id}
                                  >
                                    {kyc.kyc_email_id}
                                  </span>
                                </div>
                              </td>
                              <td className='max-w-100px'>
                                <span className={`badge ${setBadgeColor(kyc.account_kyc_status)}`}>
                                  {kyc.account_kyc_status_msg}
                                </span>
                              </td>
                              <td className='max-w-50px'>
                                <div className='d-flex flex-shrink-0'>
                                  <Link
                                    to={`/approve_kyc/${kyc.account_kyc_uuid}`}
                                    className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  >
                                    <i
                                      className='bi bi-eye-fill bi-4x fs-2'
                                      title='View KYC Account'
                                    ></i>
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          )
                        })
                      )}
                    </tbody>
                    {/* end::Table body */}
                  </table>
                  {/* end::Table */}
                </div>
              </div>
            </div>
          </div>
          {/* End: Table */}

          {/* Begin: Pagination */}
          {allKYC && pageCount > 1 && (
            <PaginationComponent
              itemsPerPage={itemsPerPage}
              dataLength={dataLength}
              setItemOffset={setItemOffset}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pageCount={pageCount}
            />
          )}
          {/* End: Pagination */}
        </div>
      )}
    </>
  )
}

export default ApproveKYCHome
